/* Audience configs for SegmentComposer. One audience today (leads).
   Customers/segments later plug in here — the composer itself never
   hardcodes an audience. Every audience MUST point at endpoints whose
   exclusion math is server-side and structural. */

export const LEADS_AUDIENCE = {
  key: 'leads',
  noun: 'leads',
  title: 'Segment Outreach',
  subtitle: 'Filter the pipeline into a segment — exclusions are structural, not optional.',
  endpoints: {
    preview: '/leads/outreach/preview/',
    send: '/leads/outreach/send/',
    draft: '/leads/outreach/draft/',
  },
  // Kept as the pre-extraction key: Pipeline auto-reopen and any in-flight
  // founder draft read this exact name.
  draftKey: 'orx.draft.v1',
  filterGroups: [
    {
      key: 'stages',
      label: 'Stages',
      options: ['NEW', 'CONTACTED', 'QUALIFIED', 'ESTIMATE_SCHEDULED', 'ESTIMATE_SENT', 'FOLLOW_UP'],
      display: (s) => s.replace(/_/g, ' '),
    },
    { key: 'sources', label: 'Source', options: ['web', 'manual', 'import'] },
  ],
  exclusionLabels: {
    existing_customer: 'existing customers',
    converted: 'already converted',
    recently_contacted: 'recently contacted',
    opted_out: 'opted out',
    no_contact_info: 'no contact info',
  },
  quoteFilter: true,
  rowPath: (row) => `/leads/${row.id}`,
  aiGoalPlaceholder: 'State the goal — e.g. "get these leads to book a tour"',
  defaultAiGoal: 'follow up with these leads',
};

export const CUSTOMERS_AUDIENCE = {
  key: 'customers',
  noun: 'customers',
  title: 'Customer Outreach',
  subtitle: 'Segment the customer book — exclusions are structural, not optional.',
  endpoints: {
    preview: '/customers/outreach/preview/',
    send: '/customers/outreach/send/',
    // AI drafting is audience-neutral prose; the lead endpoint serves both.
    draft: '/leads/outreach/draft/',
  },
  draftKey: 'orx.customers.draft.v1',
  filterGroups: [
    // DERIVED status — computed from real evidence (completed appointment,
    // invoice, payment, accepted quote). is_active was removed: 304 "active"
    // on t6 while 320 never transacted — decorative flags don't get UI.
    // unknown_import is not offered: it is structurally quarantined.
    {
      key: 'derived', label: 'Status', options: ['customer', 'dormant', 'never_converted'],
      display: (v) => ({ customer: 'customer', dormant: 'dormant', never_converted: 'never converted' }[v] || v),
    },
    // The AI revenue engine's curated books — where the money is.
    {
      key: 'books', label: 'Book', options: ['inactive_book', 'upsell_book'],
      display: (v) => ({ inactive_book: 'inactive book', upsell_book: 'upsell targets' }[v] || v),
    },
  ],
  quoteFilter: true,
  exclusionLabels: {
    opted_out: 'opted out',
    unknown_import: 'unidentified import (quarantined)',
    scanner_completed: 'scanner says job done — Kyle CSV pending, different message',
    suppressed: 'STOP ledger',
    recently_contacted: 'recently contacted',
    no_contact_info: 'no contact info',
  },
  rowPath: (row) => `/customers/${row.id}`,
  aiGoalPlaceholder: 'State the goal — e.g. "win back inactive customers"',
  defaultAiGoal: 'reach out to these customers',
};
